import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  acceptChatbotTermsThunkService,
  getChatbotThreadsService,
  getHaveIAcceptedChatbotTermsService,
} from '../services/chatbotService';

export const acceptChatbotTermsThunk = createAsyncThunk(
  'chatbot/acceptChatbotTermsThunk',
  async (payload, { getState, rejectWithValue }) => {
    console.log('DISPATCHED:: acceptChatbotTermsThunk');

    const state = getState();
    const userSetting = state.root.userSetting;

    const userId = userSetting.user;

    try {
      const response = await acceptChatbotTermsThunkService(userId);
      console.log('response');
      console.log(response);

      return response;
    } catch (error) {
      return rejectWithValue('Failed to acceptChatbotTermsThunk');
    }
  }
);

export const getHaveIAcceptedChatbotTermsThunk = createAsyncThunk(
  'chatbot/getHaveIAcceptedChatbotTerms',
  async (payload, { getState, rejectWithValue }) => {
    console.log('DISPATCHED:: getHaveIAcceptedChatbotTermsThunk');

    const state = getState();
    const userSetting = state.root.userSetting;

    const userId = userSetting.user;

    try {
      const response = await getHaveIAcceptedChatbotTermsService(userId);
      console.log(response);
      return response;
    } catch (error) {
      return rejectWithValue('Failed to getHaveIAcceptedChatbotTermsThunk');
    }
  }
);

export const getChatbotThreadsThunk = createAsyncThunk(
  'chatbot/getChatbotThreads',
  async (payload, { getState, rejectWithValue }) => {
    console.log('DISPATCHED:: getChatbotThreadsThunk');

    const state = getState();

    const businessId = state.user.settings.activeEmployerBusinessId;
    console.log(businessId);

    try {
      const response = await getChatbotThreadsService(businessId);
      console.log(response);
      return response;
    } catch (error) {
      return rejectWithValue('Failed to getChatbotThreadsThunk');
    }
  }
);
